<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="main">
    <center>
      <div class="switch-button" @click="togglePlansType">
        <input class="switch-button-checkbox" type="checkbox" />
        <label class="switch-button-label" for="">
          <span class="switch-button-label-span">Monthly</span>
        </label>
      </div>
    </center>

    <table class="price-table">
      <tbody>
        <tr>
          <td class="price-blank" />
          <td class="price-blank" />
          <td class="price-table-popular">Best Value</td>
          <td class="price-blank" />
        </tr>
        <tr class="price-table-head">
          <td />
          <td>
            Free Forever
            <br /><small style="font-size: 12px; font-weight: 400;">
              Starter plan
            </small>
          </td>
          <td>
            Startup Plan
            <br /><small style="font-size: 12px; font-weight: 400;">
              Power-up Your Startup
            </small>
          </td>
          <td class="green-width">
            Business Plan
            <br /><small style="font-size: 12px; font-weight: 400;">
              Our complete solution
            </small>
          </td>
        </tr>
        <tr>
          <td />
          <td class="price">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 128 128"
            >
              <defs />
              <path
                d="M76.1 91.4V71.7a1 1 0 00-.2-.6l-5.7-6.9V15.4a1.1 1.1 0 00-.1-.4.5.5 0 000-.1l-5.8-10a1 1 0 00-1.7 0l-5.9 10a.5.5 0 000 .1 1.2 1.2 0 00-.1.4v48.8l-5.7 6.9a1 1 0 00-.2.6v19.7a1 1 0 001 1h10.6V95a1 1 0 102 0v-2.7h10.8a1 1 0 001-1zm-17.6-75h9.7v4h-9.7zm4.8-9l4.1 7h-8.1zM52.6 72l4-4.8v23h-4zm11.7 18.3V56.7a1 1 0 10-2 0v33.7h-3.8v-68h9.7v68zm9.8 0h-4v-23l4 4.7z"
              />
              <path
                d="M59 94.7a1 1 0 00-1 1v10.9a4.2 4.2 0 00-3.3 2.7 1 1 0 00.6 1.3 1 1 0 00.4 0 1 1 0 001-.6 2.2 2.2 0 012.8-1.4 1 1 0 10.7-1.9H60v-11a1 1 0 00-1-1zM68.7 101.2v-5.5a1 1 0 00-2 0v5.5a1 1 0 102 0zM60.2 112.8a1.4 1.4 0 011.3 1 1 1 0 001.9.3 2.5 2.5 0 014.7 1.4 1 1 0 002 0 4.6 4.6 0 00-7.4-3.6 3.4 3.4 0 00-2.5-1.1 1 1 0 000 2zM73.2 109.7a1 1 0 002 0 6.1 6.1 0 00-6.1-6.1 1 1 0 000 2 4.1 4.1 0 014.1 4zM105.2 109a9.8 9.8 0 00-19-3 6.4 6.4 0 00-2.8-.7 6.5 6.5 0 00-6.5 6.5 1 1 0 002 0 4.5 4.5 0 014.5-4.5 4.4 4.4 0 012.8 1 1 1 0 001.6-.6 7.8 7.8 0 0115.4 1.4 1 1 0 002 0zM7.8 123a8 8 0 006.2-.1 1 1 0 00-.8-1.8 6 6 0 01-8-3 6 6 0 012.9-8 9.4 9.4 0 001.5.8 1 1 0 00.4.1 1 1 0 00.4-2 7.5 7.5 0 01-1-13.2 1 1 0 00.1-1.6A4.2 4.2 0 018.1 91a4.2 4.2 0 017.1-3 1 1 0 001 .2 1 1 0 00.6-.6 5.8 5.8 0 0111.3 1.1A7.4 7.4 0 0022 96a1 1 0 002 0 5.4 5.4 0 118.6 4.4 8.9 8.9 0 00-5.4 7 6.6 6.6 0 00-1 0 6.4 6.4 0 00-4.5 1.9 1 1 0 000 1.4 1 1 0 001.4 0 4.4 4.4 0 017.5 3.1 1 1 0 002 0 6.4 6.4 0 00-3.4-5.7 6.8 6.8 0 014.2-5.9 6.8 6.8 0 019.4 5.9 1 1 0 001.4.8 4.8 4.8 0 011.8-.3 5 5 0 015 5 1 1 0 002 0 7 7 0 00-8.4-6.9 8.9 8.9 0 00-8.6-7h-.2a7.4 7.4 0 00-5.7-11.1 7.8 7.8 0 00-14.6-2.9 6.2 6.2 0 00-3.2-.9 6.2 6.2 0 00-5 10 9.4 9.4 0 00-1 13.9 8.1 8.1 0 00-3.3 4A8 8 0 007.8 123zM91.8 119.8a1 1 0 002 0 6.4 6.4 0 00-11-4.5 1 1 0 000 1.4 1 1 0 001.4 0 4.4 4.4 0 013.1-1.3 4.4 4.4 0 014.5 4.4zM125.4 103.3a7.7 7.7 0 00-3.4-6.4 8.1 8.1 0 00.7-3.3A8.3 8.3 0 00107 90a5.8 5.8 0 00-4 10.6 1 1 0 101.1-1.7 3.8 3.8 0 013.2-6.8 1 1 0 001.2-.6 6.3 6.3 0 0112.2 2 6.2 6.2 0 01-1 3.3 1 1 0 000 .8 1 1 0 00.5.6 5.6 5.6 0 011 9.5 8.4 8.4 0 00-2.8-1.6 1 1 0 10-.6 1.8 6.7 6.7 0 01-.4 12.8 1 1 0 00-.7 1.2 1 1 0 001 .8 1.1 1.1 0 00.2 0A8.7 8.7 0 00124 112a8.7 8.7 0 00-1.3-2.8 7.6 7.6 0 002.7-6z"
              />
            </svg>
            <br />Free Forever
            <br />
            <a href="#">$3 For Addition Agent/Inbox Per Month</a>
          </td>
          <td class="price">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 128 128"
            >
              <defs />
              <path
                d="M62.6 103.3a1 1 0 00-1.4 0L44 120.8a1 1 0 000 1.4 1 1 0 00.7.3 1 1 0 00.7-.3l17.3-17.3a1 1 0 000-1.5zM58.7 116.3a1 1 0 00.7-.3l7.2-7.2a1 1 0 00-1.4-1.5l-7.2 7.3a1 1 0 00.7 1.7zM55.2 117.4l-2.8 2.8a1 1 0 00.7 1.7 1 1 0 00.7-.3l2.8-2.8a1 1 0 000-1.4 1 1 0 00-1.4 0zM5.9 84.1a1 1 0 00.7.3 1 1 0 00.7-.3l17.4-17.3a1 1 0 10-1.5-1.4L6 82.7a1 1 0 000 1.4zM13.4 70l7.3-7.2a1 1 0 10-1.5-1.4L12 68.6a1 1 0 00.7 1.7 1 1 0 00.7-.3zM7.8 75.6l2.8-2.8a1 1 0 000-1.4 1 1 0 00-1.4 0l-2.8 2.8a1 1 0 000 1.4 1 1 0 00.7.3 1 1 0 00.7-.3zM68 33.6L27.1 40a1 1 0 00-.5.3L20 46.8a1 1 0 000 1.5l16.6 16.6-4.7 4.7a1 1 0 000 1.5l11.5 11.4-4.6 4.6a1 1 0 00.7 1.7 1 1 0 00.7-.3l4.6-4.6L57 96a1 1 0 001.4 0l4.7-4.7 16.7 16.6a1 1 0 001.4 0l6-6 .5-.5a1 1 0 00.3-.6L94.4 60l20.3-20.3a22.8 22.8 0 006-10.3.6.6 0 000-.2 22 22 0 00.5-3.4l1.1-11.3a8.1 8.1 0 00-8.8-8.8l-11.3 1a22.7 22.7 0 00-3.4.6h-.1a22.8 22.8 0 00-10.4 6zm-23.9 24L28.4 41.8 65.6 36zm-22-10l4.6-4.6 16 16-4.6 4.5zm58.4 58.2l-16-16 4.5-4.5 16 16zm5.6-6.3L70.5 84 92 62.4zm16.3-90.8l11.3-1.1a6.1 6.1 0 016.7 6.7l-1.1 11.3-.2 1.3-18-18 1.3-.2zm-3.6.7l19.8 19.8a21 21 0 01-5.3 9L57.7 94 46.3 82.5 75 53.7a1 1 0 000-1.4 1 1 0 00-1.5 0L45 81.1 34 70.3l10.7-10.6 45-45a21 21 0 019-5.3zM10.9 120.4a3.3 3.3 0 001.4-.3l19.5-9.1A11.2 11.2 0 1017 96.2l-9.1 19.5a3.3 3.3 0 003 4.7zm-1.2-3.9l9-19.5a9.1 9.1 0 016.8-5.2 10.2 10.2 0 011.7-.1 9.2 9.2 0 019 10.8 9.1 9.1 0 01-5.2 6.7l-19.5 9a1.3 1.3 0 01-1.8-1.7z"
              />
              <path
                d="M96.2 42.3a10.5 10.5 0 10-7.4-3 10.4 10.4 0 007.4 3zm-6-16.5a8.5 8.5 0 110 12 8.4 8.4 0 010-12z"
              />
              />
            </svg>
            <br />
            <span v-if="planType === 'monthly'">
              $19.99
            </span>
            <span v-if="planType === 'annual'">
              $229.99
              <sub><s>$239.99</s></sub>
            </span>

            <br />
            <a href="#">$2 For Addition Agent/Inbox Per Month</a>
          </td>
          <td class="price">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 128 128"
            >
              <defs />
              <path
                d="M38.6 53.2a14.6 14.6 0 0010.6-24.6 1 1 0 00-.7-.3 1.1 1.1 0 00-.7.3l-8.9 8.9-1.7-1.7a1 1 0 00-1.4 1.4l1.7 1.7-9 8.9a1 1 0 000 1.4 14.5 14.5 0 0010.1 4zm9.9-22.4a12.6 12.6 0 01-17.7 17.7z"
              />
              <path
                d="M2.7 102.7a1 1 0 00.3.7L24.5 125a1 1 0 00.7.3 1 1 0 00.7-.3l12.4-12.3a.8.8 0 00.4-.5l12.1-12a1 1 0 00.3-.2.9.9 0 00.2-.3l12.3-12.3a1 1 0 000-1.4l-8.4-8.4 1.5-1.5 11.8 11.9 3.7 6.4.1.1a1 1 0 00.1.2l5.1 5.1a1 1 0 00.7.3 1 1 0 00.7-.3L99.7 79a1 1 0 000-1.4l-5-5.1a1 1 0 00-.2-.1h-.1l-6.5-3.8-11.8-11.9 1.4-1.4 8.4 8.3a1 1 0 00.7.3 1 1 0 00.7-.3L125 26a1 1 0 000-1.4L103.5 3a1 1 0 00-1.4 0L89.7 15.4a.8.8 0 00-.4.5L77.2 28a1 1 0 00-.3.2.9.9 0 00-.2.3L64.4 40.8a1 1 0 000 1.4l8.4 8.4-1.5 1.4-11.4-11.4a1 1 0 00-1.4 0l-18 17.9a1 1 0 000 1.4L52 71.3l-1.4 1.4-8.4-8.3a1 1 0 00-1.4 0L3 102a1 1 0 00-.3.7zM29 79l9.3 9.3L27 99.5l-9.4-9.3zm10.7 10.8l9.3 9.3-11.1 11.1-9.3-9.3zm38.7 7.8L74.6 94 94 74.6l3.7 3.7zm-4.9-5.3l-2.8-5 16.8-16.7 5 2.8zm-4-6.5L67 83.6 78.7 72a1 1 0 000-1.4 1 1 0 00-1.4 0L65.7 82.2 46.3 62.8l16.5-16.5 19.4 19.4-1.7 1.7a1 1 0 101.4 1.4l1.7-1.7 2.2 2.2zm20.8-68l9.3 9.3-11 11.1L79 29zm10.7 10.8l9.4 9.3L99.2 49l-9.4-9.3zm1.9-23.4l20 20-11.1 11.2-9.3-9.3 10-10a1 1 0 000-1.4 1 1 0 00-1.5 0l-10 10-9.3-9.3zM77.7 30.3l9.3 9.3-9.6 9.7a1 1 0 000 1.4 1 1 0 001.4 0l9.6-9.7 9.3 9.4-11 11.1-20.2-20zM74.2 52l2 2-1.5 1.4-2-2zm-15-9.2l2.2 2.2L45 61.4l-2.2-2.2zm-5.8 30l1.9 2-1.5 1.4-2-2zm-12-6.2l20 20-11 11.2-9.4-9.3 9.6-9.7a1 1 0 00-1.4-1.4L39.6 87l-9.3-9.3zm-25 25l9.2 9.4-10 10a1 1 0 000 1.4 1 1 0 001.5 0l10-10 9.3 9.3-11.2 11.2-20-20zM43.6 28.2a1 1 0 00-.3-1.4 11.9 11.9 0 00-16.5 16.5 1 1 0 00.9.5 1 1 0 00.5-.2 1 1 0 00.3-1.4 9.9 9.9 0 0113.7-13.7 1 1 0 001.4-.3z"
              />
              <path
                d="M38.6 32.3a1 1 0 10.9-1.8 6.7 6.7 0 00-9 9 1 1 0 00.9.5 1 1 0 00.9-1.4 4.7 4.7 0 016.3-6.3z"
              />
              />
            </svg>
            <br />
            <span v-if="planType === 'monthly'">
              $99.99
            </span>
            <span v-if="planType === 'annual'">
              $1099.00
              <sub><s>$1288.99</s></sub>
            </span>
            <br />
            <a href="#">$2 For Addition Agent/Inbox Per Month</a>
          </td>
        </tr>
        <tr>
          <td />
          <td
            v-for="plan in plans"
            :key="plan.product_id[0] + '-cta'"
            :class="
              plan.name == 'Startups Plan'
                ? 'price-table-popular-btn price'
                : 'price'
            "
          >
            <a
              v-if="currentPlan.stripe_product_id != plan.product_id[0]"
              class="card__cta cta"
              @click="pressHandler(plan.price_ids[0])"
            >
              Upgrade
            </a>

            <a
              v-if="currentPlan.stripe_product_id == plan.product_id[0]"
              disabled
              class="card__cta cta selected disabled"
            >
              Selected
            </a>
          </td>
        </tr>
        <tr v-for="feature in feature_list" :key="feature.key">
          <td class="feature-cell">
            <a
              v-tooltip.right="feature.description"
              :href="`#feature-description-${feature.key}`"
              class="price-table-help"
            >
              <svg
                class="svg-inline--fa fa-question-circle fa-w-16 fa-fw"
                aria-hidden="true"
                data-prefix="far"
                data-icon="question-circle"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                />
              </svg>
            </a>
            {{ feature.name }}
          </td>

          <td
            v-for="plan in plans"
            :key="plan.product_id[0] + '-features'"
            class="feature-cell"
          >
            <span v-if="plan.features.split(' ').includes(feature.key)">
              <svg
                class="svg-inline--fa fa-check fa-w-16"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="check"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                />
              </svg>
              <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="32"
                height="32"
                x="0"
                y="0"
                viewBox="0 0 24 24"
                style="enable-background:new 0 0 512 512"
                xml:space="preserve"
                class=""
              >
                <g>
                  <switch>
                    <g>
                      <g fill="#02bc7d">
                        <path
                          d="M9.7 11.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.2.2.4.3.7.3s.5-.1.7-.3l7-8c.3-.5.3-1.1-.2-1.4-.4-.3-1-.3-1.3.1L12 13.5z"
                          fill="#5336ca"
                          opacity="1"
                          data-original="#02bc7d"
                          class=""
                        />
                        <path
                          d="M21 11c-.6 0-1 .4-1 1 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-2.1.8-4.1 2.3-5.6C7.8 4.8 9.8 4 12 4c.6 0 1.3.1 1.9.2.5.2 1.1-.1 1.3-.7s-.2-1-.7-1.2h-.1c-.8-.2-1.6-.3-2.4-.3C6.5 2 2 6.5 2 12.1c0 2.6 1.1 5.2 2.9 7 1.9 1.9 4.4 2.9 7 2.9 5.5 0 10-4.5 10-10 .1-.6-.4-1-.9-1z"
                          fill="#5336ca"
                          opacity="1"
                          data-original="#02bc7d"
                          class=""
                        />
                      </g>
                    </g>
                  </switch>
                </g>
              </svg> -->
            </span>
            <span v-else>
              <svg
                class="svg-inline--fa fa-times fa-w-11"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="times"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 352 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                />
              </svg>
            </span>
          </td>
        </tr>
        <tr>
          <td />
          <td
            v-for="plan in plans"
            :key="plan.product_id[0] + '-cta'"
            :class="
              plan.name == 'Startups Plan'
                ? 'price-table-popular-btn price'
                : 'price'
            "
          >
            <a
              v-if="currentPlan.stripe_product_id != plan.product_id[0]"
              class="card__cta cta"
              @click="pressHandler(plan.price_ids[0])"
            >
              Upgrade
            </a>

            <a
              v-if="currentPlan.stripe_product_id == plan.product_id[0]"
              disabled
              class="card__cta cta selected disabled"
            >
              Selected
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    currentAccount: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },
  data() {
    return {
      currentPlan: this.currentAccount.custom_attributes,
      plans: [],

      quantity: 1,
      feature_list: [
        {
          key: 'inbox_management',
          name: 'Inbox Management',
          description:
            'Centralize messages from all channels into a single inbox for efficient management and response.',
        },
        {
          key: 'channel_website',
          name: 'Website Integration',
          description:
            'Embed our service directly on your website to provide seamless customer support.',
        },
        {
          key: 'crm',
          name: 'CRM',
          description:
            'Manage your customer relationships with integrated tools for tracking customer satisfaction.',
        },
        {
          key: 'agent_management',
          name: 'Agent Management',
          description:
            'Oversee your support or sales agents, manage permissions, and track performance all in one place.',
        },
        {
          key: 'team_management',
          name: 'Team Management',
          description:
            'Organize your agents into teams, manage workflows, and assign tasks to improve collaboration and efficiency.',
        },
        {
          key: 'labels',
          name: 'Labels',
          description:
            'Use labels to categorize conversations, prioritize responses, and filter messages for better organization.',
        },
        {
          key: 'channel_facebook',
          name: 'Meta Integration',
          description:
            'Connect with your customers on Meta platforms like Facebook and Instagram directly through our platform.',
        },
        {
          key: 'custom_reply_email',
          name: 'Custom Reply Email',
          description:
            'Customize the reply-to email address for outgoing messages to maintain brand consistency and recognition.',
        },
        {
          key: 'custom_reply_domain',
          name: 'Custom Reply Domain',
          description:
            'Use your own domain for sending emails, enhancing brand visibility and trust among recipients.',
        },
        {
          key: 'email_continuity_on_api_channel',
          name: 'Email Continuity on API Channel',
          description:
            'Ensure uninterrupted email communication even when customer left your communication channel',
        },
        {
          key: 'inbound_emails',
          name: 'Inbound Emails',
          description:
            'Efficiently manage incoming emails, automatically sorting and routing them to the appropriate team or agent.',
        },
        {
          key: 'channel_email',
          name: 'Email Integration',
          description:
            'Seamlessly integrate email communication into your platform, allowing for centralized management of email interactions.',
        },
        {
          key: 'canned_responses',
          name: 'Canned Responses',
          description:
            'Save time by using pre-written responses to frequently asked questions or common inquiries.',
        },
        {
          key: 'channel_api',
          name: 'Mobile SDK / Channel API',
          description:
            'Integrate our services into your mobile apps or software through our SDK or direct API access for customized solutions.',
        },
        {
          key: 'custom_attributes',
          name: 'Custom Attributes',
          description:
            'Define custom attributes for contacts or conversations to track specific data points relevant to your business needs.',
        },
        {
          key: 'automations',
          name: 'Automations',
          description:
            'Automate repetitive tasks, workflows, and responses to increase efficiency and allow your team to focus on higher-value interactions.',
        },
        {
          key: 'reports',
          name: 'Reports',
          description:
            'Generate detailed reports on various metrics to analyze performance, customer satisfaction, and operational efficiency.',
        },
        {
          key: 'help_center',
          name: 'Help Center',
          description:
            'Provide your customers with a self-service knowledge base to find answers to their questions, reducing the need for direct contact.',
        },
        {
          key: 'macros',
          name: 'Macros',
          description:
            'Use macros to perform batch actions  at once, such as sending bulk responses or updating statuses.',
        },
        {
          key: 'audit_logs',
          name: 'Audit Logs',
          description:
            'Track and record every action taken within the platform for security, compliance, and troubleshooting purposes.',
        },
        {
          key: 'disable_branding',
          name: 'Disable Branding',
          description:
            "Remove or customize the platform's branding from customer-facing interfaces for a fully branded experience.",
        },
      ],
      planType: 'monthly',
    };
  },
  mounted() {
    this.currentPlan = this.currentAccount.custom_attributes;
    this.quantity = this.currentAccount.custom_attributes.subscribed_quantity;

    // eslint-disable-next-line no-unused-vars
    const development_plans = [
      {
        name: 'Free Plan',
        product_id: ['prod_ObXVn8k4JorxrX'],
        price_ids: ['price_1NyDoAHgNmyioBtLS6Rx8aYe'],
        default_quantity: 1,
        supportAnnual: false,
        features:
          'inbox_management channel_website crm agent_management team_management labels',
      },
      {
        name: 'Startups Plan',
        product_id: ['prod_ObXW7NAfsbjfhd'],
        price_ids: ['price_1NyDlpHgNmyioBtL8EccbUpf'],
        default_quantity: 1,
        supportAnnual: true,
        features:
          'inbox_management channel_website crm agent_management team_management channel_facebook custom_reply_email custom_reply_domain email_continuity_on_api_channel inbound_emails channel_email labels canned_responses voice_recorder channel_api',
      },
      {
        name: 'Business Plan',
        product_id: ['prod_ObXXYZkTuqzyRb'],
        price_ids: ['price_1NyDpEHgNmyioBtLsLzZ1vDR'],
        default_quantity: 1,
        supportAnnual: true,
        features:
          'inbox_management channel_website crm agent_management team_management channel_facebook custom_reply_email custom_reply_domain email_continuity_on_api_channel inbound_emails channel_email labels canned_responses voice_recorder channel_api custom_attributes automations reports help_center macros disable_branding audit_logs',
      },
    ];

    const production_plans = [
      {
        name: 'Free Plan',
        product_id: ['prod_OmBnfM6LZzMcbV'],
        price_ids: ['price_1Nye03HgNmyioBtLdAxZhiFv'],
        default_quantity: 1,
        supportAnnual: false,
        features:
          'inbox_management channel_website crm agent_management team_management labels',
      },
      {
        name: 'Startups Plan',
        product_id: ['prod_OmBnfLh3zLWzpN'],
        price_ids: [
          'price_1OsHMQHgNmyioBtLWAvpsS70',
          'price_1NydQOHgNmyioBtLZmKdWd57',
        ],
        default_quantity: 1,
        supportAnnual: true,
        features:
          'inbox_management channel_website crm agent_management team_management channel_facebook custom_reply_email custom_reply_domain email_continuity_on_api_channel inbound_emails channel_email labels canned_responses voice_recorder channel_api',
      },
      {
        name: 'Business Plan',
        product_id: ['prod_OmBo09h8HU0Yw2'],
        price_ids: [
          'price_1OsHQHHgNmyioBtLwg6IjTjA',
          'price_1NyeWOHgNmyioBtLMHY2hgIG',
        ],
        default_quantity: 1,
        supportAnnual: true,
        features:
          'inbox_management channel_website crm agent_management team_management channel_facebook custom_reply_email custom_reply_domain email_continuity_on_api_channel inbound_emails channel_email labels canned_responses voice_recorder channel_api custom_attributes automations reports help_center macros disable_branding audit_logs',
      },
    ];

    // this.plans = development_plans;
    this.plans = production_plans;
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    pressHandler(price_id) {
      const { stripe_subscription_id } = this.currentPlan;
      this.$store.dispatch('accounts/checkout', {
        subscription_id: stripe_subscription_id,
        // price_id: null,
        // quantity: null,
        price_id: price_id,
        // quantity: this.quantity,
      });
    },
    increment() {
      this.quantity += 1;
    },
    decrement() {
      this.quantity -= 1;
    },
    togglePlansType() {
      if (this.planType === 'monthly') {
        this.planType = 'annual';
        return;
      }

      this.planType = 'monthly';
    },
  },
};
</script>

<style scoped>
.cta.selected {
  /* border: 2px #f9ad31 solid; */
  background: #9664eb !important;
}
.price-table {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
  border: 0 none;
}
.price-table tr:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.price-table tr td {
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  padding: 8px 24px;
  font-size: 14px;
}
.price-table tr td:first-child {
  border-left: 0 none;
}
.price-table tr td:not(:first-child) {
  text-align: center;
}
.price-table tr:nth-child(even) {
  background-color: #ffffff;
}
.price-table tr:hover {
  background-color: #eeeeee;
}
.price-table .fa-check {
  color: #5336ca;
}
.price-table .fa-times {
  color: #d8d6e3;
}

/* Highlighted column */
/* .price-table tr:nth-child(2n) td:nth-child(3) {
  background-color: rgba(216, 214, 227, 0.25);
} */
.price-table tr:nth-child(2) td:nth-child(3) {
  background-color: #5336ca;
}

.price s {
  color: #5b5b5b;
}

.price-table tr.price-table-head td {
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
}
.price-table tr.price-table-head {
  background-color: #5336ca;
  color: #ffffff;
}
.price-table td.price {
  color: #f43f54;
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 600;
}
.price-table td.price a {
  background-color: var(--w-100);
  color: var(--w-700);
  padding: 12px 32px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  border-radius: 64px;
  cursor: default;
}

.price-table td.price a.card__cta {
  background-color: #5336ca;
  color: #ffffff;
  cursor: pointer;
}

.price-table td.price-table-popular-btn a.card__cta {
  background-color: #f9ad31;
  color: #ffffff;
  cursor: pointer;
}

.price-table td.price-table-popular {
  border-top: 3px solid #f9ad31;
  border-right: 3px solid #f9ad31;
  border-left: 3px solid #f9ad31;
  color: #5336ca;
  text-transform: uppercase;
  font-size: 12px;
  padding: 12px 48px;
  font-weight: 700;
}

.price-table td.price-table-popular a {
  background: #f9ad31;
  color: #5336ca;
  text-transform: uppercase;
}

.price-table tr:nth-child(2) td:nth-child(3) {
  background-color: rgba(216, 214, 227, 0.15);
  border-left: 2px solid #f9ad31;
  border-right: 2px solid #f9ad31;
  border-bottom: 2px solid #f9ad31;
  padding: 8px 48px;
}
/* .price-table tr:last-child td:nth-child(3) {
  background-color: rgba(216, 214, 227, 0.15);
  border-bottom: 2px solid #f9ad31;
  padding: 8px 48px;
} */

.price-table .price-blank {
  background-color: #fafafa;
  border: 0 none;
}

.price-table .price svg {
  width: 90px;
  fill: #5336ca;
}

.price-table .feature-cell svg {
  width: 16px;
  fill: #5336ca;
}

body {
  background-color: #155fff;
}

.switch-button {
  box-sizing: border-box;
  background: var(--w-50);
  border-radius: 30px;
  overflow: hidden;
  width: 240px;
  text-align: center;
  font-size: 18px;
  letter-spacing: 1px;
  color: var(--w-700);
  position: relative;
  padding-right: 120px;
  position: relative;
}
.switch-button:before {
  content: 'Annual';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  pointer-events: none;
}
.switch-button-checkbox {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
}
.switch-button-checkbox:checked + .switch-button-label:before {
  transform: translateX(120px);
  transition: transform 300ms linear;
}
.switch-button-checkbox + .switch-button-label {
  position: relative;
  padding: 6px 0;
  display: block;
  margin: 0px;
  user-select: none;
  pointer-events: none;
  color: var(--w-700);
}
.switch-button-checkbox + .switch-button-label:before {
  content: '';
  background: #fff;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 30px;
  transform: translateX(0);
  transition: transform 300ms;
}
.switch-button-checkbox + .switch-button-label .switch-button-label-span {
  position: relative;
}
</style>
